// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1Rq3A"};
    if(module.hot) {
      // 1763050442302
      var cssReload = require("/var/www/chunsing-app-ui/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  